import { useEffect, useState } from "react";
import styles from "./receipt-list.module.css";

interface Receipt {
  id: string;
  fileName: string;
  fileUrl: string; // This is the reference/pathname
  uploadedAt: string;
}

function handleOpenReceipt(fileUrl: string) {
  return async () => {
    try {
      const res = await fetch(
        `/api/receipts/get-receipt-url?reference=${encodeURIComponent(fileUrl)}`,
      );
      const data = await res.json();
      if (data.url) {
        window.open(data.url, "_blank", "noopener,noreferrer");
      } else {
        alert("Could not get receipt URL.");
      }
    } catch (e) {
      alert("Could not get receipt URL.");
    }
  };
}

export function ReceiptList({ transactionId }: { transactionId: string }) {
  const [receipts, setReceipts] = useState<Receipt[]>([]);

  useEffect(() => {
    const fetchReceipts = async () => {
      const res = await fetch(
        `/api/receipts/my-receipts?transactionId=${transactionId}`,
      );
      const data = await res.json();
      if (data.receipts) {
        setReceipts(data.receipts);
      } else {
        setReceipts([]);
      }
    };
    fetchReceipts();
  }, [transactionId]);

  return (
    <div className={styles.container}>
      <h3>Uploaded Receipts</h3>
      {receipts.length === 0 && <p>No receipts uploaded.</p>}
      <ul>
        {receipts.map((receipt) => (
          <li key={receipt.id}>
            <button
              type='button'
              className={styles.receiptButton}
              onClick={handleOpenReceipt(receipt.fileUrl)}
            >
              {receipt.fileName}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
